<br><br><br><br><br><br><br><br>
<p>
  FormProductoReactivoDinamico works!
</p>
<div class="container">
  <div class="row">
    <div class="col-md-12">
      <form class="bg-light p-3"
            [formGroup]="miFormulario"
            autocomplete="off"
            (ngSubmit)="guardar()">
        <div class="row">
          <div class="col-md-12" >
            <div class="form-group">
              <label for="">Nombre</label>
              <input type="text" class="form-control" formControlName="nombre">
              <small class="form-text text-danger"
                 *ngIf="campoEsValido('nombre')">Debe ser minimo 3 caracteres</small>
            </div>
          </div >
        </div>
        <!--Agregar Favorito-->
        
        <div class="row">
          <div class="col-md-12">
            <label for="">Agregar</label>
            <div class="input-group">
             <input type="text" class="form-control">

             <button class="btn btn-danger" type="button">Agregar</button>
            </div>
          </div>
        </div>
        <!--Listar Favoritos-->
        <div class="row">
          <label for="">Favoritos</label>
          <div class="col-md-12" formArrayName="favoritos">

            <div class="input-group mb-1"
                 *ngFor="let favorito of favoritosArr.controls; let i = index">
              
                 <input type="text" class="form-control"
                        [formControlName]= "i">

              <button class="btn btn-info" type="button">Eliminar</button>
            </div>

          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <button class="btn btn-primary mt-3" type="submit">Registrar</button>
          </div>
        </div>
        <div class="col-md-12">
          <span>Valid</span>
          <pre>{{miFormulario.valid | json}}</pre>
          
          <span>Pristine</span>
          <pre>{{miFormulario.pristine | json}}</pre>
    
          <span>Touched</span>
          <pre>{{miFormulario.touched | json}}</pre>
    
          <span>Value</span>
          <pre>{{miFormulario.value | json}}</pre>
    
        </div>

      </form>
    </div>
  </div>
</div>
